export const GLOBAL_TYPES = {
    SERVER_IP: 'SERVER_IP',
    SERVER_PORT: 'SERVER_PORT',
    LAST_VISIT_TIME: 'LAST_VISIT_TIME',
    ERRORS: 'ERRORS',
    COST_MODE: 'COST_MODE',

    ALERTS: 'ALERTS',
    ALERTS_IMPORTANT: 'ALERTS_IMPORTANT'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/device/types/global.types.js